import type { MeContext } from '@vizit/api';
import { ROLE, SCOPE_TYPE } from '../constants';
import { hasGrant } from './grants';
import { isSuperAdmin } from './is-super-admin';

export function hasOrgAdminGrant(context: MeContext): boolean {
  return hasGrant(context, ROLE.OrgAdmin, SCOPE_TYPE.Organization, context.organization.id);
}

export function isOrgAdmin(context: MeContext): boolean {
  return isSuperAdmin(context) || hasOrgAdminGrant(context);
}
